if (!customElements.get('tabbed-content')) {
  class TabbedContent extends HTMLElement {
    constructor() {
      super();
      this.abortController = null;
    }

    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();

      this.tabs = Array.from(
        this.querySelectorAll('.tabbed-content--tabs button')
      );

      this.contents = Array.from(
        this.querySelectorAll(':scope > .tabbed-content--content')
      );

      if (!this.tabs.length || !this.contents.length) return;

      this.tabs.forEach((tab, index) => {
        tab.setAttribute('type', 'button');

        tab.addEventListener(
          'click',
          (event) => {
            event.preventDefault();
            this.selectTab(index);
          },
          { signal: this.abortController.signal }
        );
      });

      const selectedIndex = parseInt(this.getAttribute('selected-index') || '0', 10);
      this.selectTab(Number.isFinite(selectedIndex) ? selectedIndex : 0);
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    selectTab(index) {
      if (index < 0 || index >= this.contents.length) index = 0;

      this.tabs.forEach((tab, tabIndex) => {
        tab.classList.toggle('active', tabIndex === index);
        tab.setAttribute('aria-selected', tabIndex === index ? 'true' : 'false');
      });

      this.contents.forEach((content, contentIndex) => {
        content.classList.toggle('active', contentIndex === index);
      });

      this.setAttribute('selected-index', String(index));
    }
  }

  customElements.define('tabbed-content', TabbedContent);
}